<input #searchBox
  class="maps-search form-control leaflet-map-search"
  type="text"
  placeholder="Inserisci un indirizzo..."
  (input)="getSearchLocation()"
/>
